import React from 'react'
import T from 'prop-types'
import { Snackbar } from '@material-ui/core'
import './loader.scss'
import { injectIntl } from 'react-intl'
import Loader from './Loader'
import messages from './translate'

function NoInternetLoader({ loading, intl: { formatMessage } }) {
  if (!loading) {
    return null
  }

  return (
    <div className="loader-container circle-loader no-internet-loader">
      <Snackbar
        open
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        message={formatMessage(messages.noInternetMessage)}
        className="no-internet-message"
      />
      <Loader />
    </div>
  )
}

NoInternetLoader.propTypes = {
  intl: T.object.isRequired,
  loading: T.bool.isRequired,
}

export default injectIntl(NoInternetLoader)
